import { useError } from 'contexts/error';
import { useInfo } from 'contexts/info';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client/react';
import { DashboardLink } from 'utils/link';
import ConfirmMutation from 'mutations/space/confirm_invitation';
import Loader from 'components/loader';

const InvitationConfimation = () => {
  const { token } = useParams();
  const setInfo = useInfo();
  const setError = useError();
  const navigate = useNavigate();

  const [confirmMutation, { loading }] = useMutation(ConfirmMutation, {
    onCompleted: ({ success }) => {
      if (!success) {
        setError('error.user.space.confirm');
      } else {
        setInfo('info.user.space.confirmed');
      }
      navigate(DashboardLink());
    },
    onError: () => {
      setError('error.user.space.confirm');
    },
  });

  confirmMutation({ variables: { token } });

  if (loading) {
    return <Loader />;
  }

  return null;
};

export default InvitationConfimation;
